import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting'
import * as Highcharts from 'highcharts';
import { DatePipe } from '@angular/common';
import { Alert } from 'selenium-webdriver';
HighchartsExportData(Highcharts);
HighchartsExporting(Highcharts);
@Component({
  selector: 'app-wms-inverter-data',
  templateUrl: './wms-inverter-data.component.html',
  styleUrls: ['./wms-inverter-data.component.scss']
})
export class WmsInverterDataComponent implements OnInit {
  public highcharts = Highcharts;
  tabselection: any;

  /**After testing use same chartOption REMOVE REPEATED chart Options */
  chartDayOptions = {
    chart: {
      type: "spline"
    },
    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Power (KW)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartDayOptionsDg = {
    chart: {
      type: "column"
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartMonthOptions = {
    chart: {
      type: 'column'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartMonthOptionsInv = {
    chart: {
      type: 'column'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartYearOptionsInv = {
    chart: {
      type: 'column'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartYearOptions = {
    chart: {
      type: 'column'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartLifeTimeOptions = {
    chart: {
      type: 'column'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  chartLifeTimeOptionsInv = {
    chart: {
      type: 'column'
    },

    tooltip: {
      valueSuffix: ''
    },
    title: {
      text: ''
    },
    xAxis: [{}],
    yAxis: {
      title: {
        text: 'Energy (KWh)'
      }
    },
    series: [{}],
    exporting: {
      buttons: {
        contextButton: {
          menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
        }
      }
    }
  };
  private ResponsWmsUserInverterList: Subject<any> = new Subject();
  private ResponseWmsInverterDetails: Subject<any> = new Subject();
  private ResponseParmeterAndValue: Subject<any> = new Subject();
  public wmsinverterform: FormGroup;
  public dayform: FormGroup;
  public monthform: FormGroup;

  public yearform: FormGroup;
  public updateFlag: boolean = false;
  pipe = new DatePipe('en-US');
  role: any;
  roleName: string;
  public wmsInverterDetails_id: any;
  public wmsSerial_no;
  public wmsSubDevice_id;
  public wmsInverterList = [];
  public wmsInverterDetails: any[];
  public wmsparameterAndValue: any = [];
  public wmsConnectedSolarCapacity: any;
  public wmsConnectedSolarCapacityUnit: any;
  public wmsInverter_Rating: any;
  public wmscurrentPower: any;
  public wmscurrentPowerUnit: any;
  public wmstotalGenration: any;
  public wmstotalPeakPower: any;
  public wmstotalPeakPowerUnit: any;
  public wmsmonthGeneration: any;
  public wmsmonthGenerationUnit: any;
  public wmstotalGeneration: any;
  public wmstotalGenerationUnit: any;
  public wmstotalTodaysGenerationUnit: any;
  public wmsInverterDetailsObject: any = {};
  public wmsParameterListRequestObject: { serial_no: any; sub_device_id: any; };
  inverterEfficency: any;
  public login_Id = localStorage.login_id;
  public selectedTabSection: string;
  public maxDate = new Date();
  public minDate = new Date(2017, 1, 1);
  dayGraphObj: { date: any; user_id: any; serial_no: any; sub_device_id: any; };
  dayGraphObjInv: { date: any; user_id: any; };
  categories_Day: any[];
  data_Day: any[];
  graphMonthObj: { month: string; year: string; user_id: any; serial_no: any; sub_device_id: any; };
  graphMonthObjInv: { month: string; year: string; user_id: any };
  month_Data: any[];
  month_Categories: any[];
  Inv_Data: any[];
  energy: any[];
  Inv_Data_Mon: any[];
  energy_mon: any[];

  graphYearObj: { year: string; user_id: any; serial_no: any; sub_device_id: any; };
  graphYearObjInv: { year: string; user_id: any };
  years_Data: any[];
  years_Categories: any[];
  graphDetailsArray: any;
  graphLifeTimeObj: { start_year: string; user_id: any; serial_no: any; sub_device_id: any; };
  graphLifeTimeObjInv: {year: string; user_id: any};
  LifeTimeCategories: any[];
  LifeTimeData: any[];
  DayPowerSumWmsUser: any;
  DayPowerSumWmsUserInv: any;
  DaySpcificYeildWmsUser: any;
  DaySpcificYeildWmsUserInv: any;
  monthPowerSumWmsUser: any;
  monthSpcificYeildWmsUser: any;
  monthPowerSumWmsUserInv: any;
  monthSpcificYeildWmsUserInv: any;

  yearPowerSumWmsUser: any;
  yearSpcificYeildWmsUser: any;

  yearPowerSumWmsUserInv: any;
  yearSpcificYeildWmsUserInv: any;

  lifeTimePowerSumWmsUser: any;
  lifeTimePowerSumWmsUserAll: any;
  inv_name: any;

  constructor(private toastr: ToastrService, private fb: FormBuilder, private router: Router, private dashboardService: DashboardService) {

    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {
      this.roleName = 'normal';
    }

  }

  ngOnInit() {
    this.selectedTabSection = 'Day';
   // this.selectedTabSection = 'DayInv'

    // for wms user Drop Down form
    this.wmsinverterform = this.fb.group({
      Wmsinverter_id: [null, Validators.required],
    });
    this.dayform = this.fb.group({
      dayDate: ["", Validators.required],
    });
    this.dayform.get('dayDate').setValue(new Date());
    // for wms user month select form
    this.monthform = this.fb.group({
      monthYear: ["", Validators.required],
    });
    // for wms user year select form
    this.yearform = this.fb.group({
      year: ["", Validators.required],
    });

    if (this.roleName == 'wms') {
      this.getWmsInverterList();
    }

    this.tabselection = 'parameter_trends'
  }
  /* for inverter wise*/
  showAllLifeTimeGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.wmsUseInverterLifeTimeGraph();
  }
  showAllYearGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.yearform.get('year').setValue(new Date());
    this.wmsUseInverterYearGraph();
  }
  showAllMonthGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.monthform.get('monthYear').setValue(new Date());
    this.wmsUserInverterMonthGraph();
     }
  showAllDayGraphTab(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.dayform.get('dayDate').setValue(new Date());
    this.normalUserInverterDayGraph();
  }
  /* for inverter wise*/

  /* for all inverter*/
  showAllLifeTimeGraphTabInv(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.wmsUseInverterLifeTimeInvGraph();
  }
  showAllYearGraphTabInv(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.yearform.get('year').setValue(new Date());
    this.wmsUseInverterYearInvGraph();
  }
  MonthGraphTabInv(selectedTabSection) {
    this.selectedTabSection = selectedTabSection;
    this.monthform.get('monthYear').setValue(new Date());
    this.wmsUserInverterMonthInvGraph();
  }
  showAllDayGraphTabInv(selectedTabSection) {

    this.selectedTabSection = selectedTabSection;
    this.dayform.get('dayDate').setValue(new Date());
    this.normalUserInverterWiseDayGraph();
  }
  /* for inverter wise*/


  // get inverter list on drop Down wms user
  public getWmsInverterList() {
    this.dashboardService.getWmsInverterList()
      .pipe(takeUntil(this.ResponsWmsUserInverterList))
      .subscribe(
        async result => {
          this.wmsInverterList = [];
          if (result.status) {
            for (let index = 0; index < result.resultObject.length; index++) {
              if(result.resultObject[index]['sub_device_type_id'] == '1' || result.resultObject[index]['sub_device_type_id'] == 1){
                this.wmsInverterList.push(result.resultObject[index]);
              }
            }
            // this.wmsInverterList = result.resultObject;
            this.wmsSerial_no = this.wmsInverterList[0].serial_no;
            this.wmsSubDevice_id = this.wmsInverterList[0].sub_device_id;
            this.wmsInverterDetails_id = this.wmsInverterList[0].id;
            this.wmsinverterform.get('Wmsinverter_id').setValue(this.wmsInverterDetails_id)
            this.geWmsParameterAndValueList();
            this.normalUserInverterDayGraph();
            this.getwmsInverterDetailsById();

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // select inverter dropdown for wms user
  onWmsInverterChange(value) {
    this.wmsInverterDetails_id = value;
    for (let i = 0; i < this.wmsInverterList.length; i++) {
      if (this.wmsInverterList[i].id == value) {
        this.wmsSubDevice_id = this.wmsInverterList[i].sub_device_id;
        this.wmsSerial_no = this.wmsInverterList[i].serial_no;
      }
    }
    this.geWmsParameterAndValueList();
    this.getwmsInverterDetailsById();

    if (this.selectedTabSection == 'Day') {
      this.normalUserInverterDayGraph();
   //   this.normalUserInverterWiseDayGraph();
    }

    else if (this.selectedTabSection == 'Month') {

      this.wmsUserInverterMonthGraph();
    } else if (this.selectedTabSection == 'Year') {
      this.wmsUseInverterYearGraph();
    } else if (this.selectedTabSection == 'LifeTime') {
      this.wmsUseInverterLifeTimeGraph()
    } else if (this.selectedTabSection == 'DayInv') {
      this.normalUserInverterWiseDayGraph();
    } else if (this.selectedTabSection == 'MonthInv') {
        this.wmsUserInverterMonthInvGraph();

    } else if (this.selectedTabSection == 'YearInv') {
      this.wmsUseInverterYearInvGraph();
    } else if (this.selectedTabSection == 'LifeTimeInv') {
      this.wmsUseInverterLifeTimeInvGraph()
    }
  }
  // inverter Details Dashboard data for wms user
  public getwmsInverterDetailsById() {

    this.wmsInverterDetailsObject = {
      inverter_id: this.wmsInverterDetails_id
    }
    this.dashboardService.getWmsInverterDetailsById(this.wmsInverterDetailsObject)
      .pipe(takeUntil(this.ResponseWmsInverterDetails))
      .subscribe(
        async result => {
          this.wmsInverterDetails = [];
          if (result.status) {
            this.wmsInverterDetails = result.resultObject;
            var solarCapacity = this.wmsInverterDetails[0].connected_solar_capacity;
            let a = solarCapacity.split(" ");
            this.wmsConnectedSolarCapacity = a[0];
            this.wmsConnectedSolarCapacityUnit = a[1];
            this.wmsInverter_Rating = this.wmsInverterDetails[0].inverter_rating;
            var current = this.wmsInverterDetails[0].current_power;
            let b = current.split(" ");
            this.wmscurrentPower = b[0];
            this.wmscurrentPowerUnit = b[1];
            var todysGen = this.wmsInverterDetails[0].today_generation;
            let c = todysGen.split(" ");
            this.wmstotalGenration = c[0];
            this.wmstotalTodaysGenerationUnit = c[1];
            var peackPower = this.wmsInverterDetails[0].today_peak_power;
            let d = peackPower.split(" ");
            this.wmstotalPeakPower = d[0];
            this.wmstotalPeakPowerUnit = d[1];

            var monthGen = this.wmsInverterDetails[0].month_generation;
            let e = monthGen.split(" ");
            this.wmsmonthGeneration = e[0];
            this.wmsmonthGenerationUnit = e[1];

            var totalGen = this.wmsInverterDetails[0].total_generation;
            let f = totalGen.split(" ");
            this.wmstotalGeneration = f[0];
            this.wmstotalGenerationUnit = f[1];
            this.inverterEfficency = Number(this.wmsInverterDetails[0].inverter_efficiency).toFixed(2);

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);
              this.wmsConnectedSolarCapacity = 0;
              this.wmsConnectedSolarCapacityUnit = "";
              this.wmsInverter_Rating = 0;
              this.wmscurrentPower = 0;
              this.wmscurrentPowerUnit = "";
              this.wmstotalGenration = 0;
              this.wmstotalTodaysGenerationUnit = "";
              this.wmstotalPeakPower = 0;
              this.wmstotalPeakPowerUnit = "";
              this.wmsmonthGeneration = 0;
              this.wmsmonthGenerationUnit = "";
              this.wmstotalGeneration = 0;
              this.wmstotalGenerationUnit = "";
              this.inverterEfficency = 0;

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // Wms User Dashboard Parameters and value list
  public geWmsParameterAndValueList() {

    this.wmsParameterListRequestObject = {
      serial_no: this.wmsSerial_no,
      sub_device_id: this.wmsSubDevice_id
    }
    this.dashboardService.getWmsParameterAndValueList(this.wmsParameterListRequestObject)
      .pipe(takeUntil(this.ResponseParmeterAndValue))
      .subscribe(
        async result => {
          this.wmsparameterAndValue = []
          if (result.status) {
            this.wmsparameterAndValue = result.resultObject;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // Day Graph for wms User
  dateChange() {
    this.normalUserInverterDayGraph();
  }

  // day graph for INEVERTERWISE user daywise
  dateChangeInv() {
    this.normalUserInverterWiseDayGraph();
  }

  //  for month graph
  changeMonth() {
     this.wmsUserInverterMonthGraph();
  }
  changeMonthInv(){
     this.wmsUserInverterMonthInvGraph();
  }
  //  for year graph
  changeYear() {
    this.wmsUseInverterYearGraph();
  }
  changeYearInv(){
    this.wmsUseInverterYearInvGraph();
  }
  // inverterwise day graph
  public normalUserInverterDayGraph() {

    this.dayGraphObj = {
      date: this.pipe.transform(this.dayform.controls['dayDate'].value, "dd-MM-yyyy"),
      user_id: this.login_Id,
      serial_no: this.wmsSerial_no,
      sub_device_id: this.wmsSubDevice_id
    }
    this.dashboardService.normalUserEnergyDayGraph(this.dayGraphObj)
      .pipe(takeUntil(this.ResponseWmsInverterDetails))
      .subscribe(
        async result => {
          this.categories_Day = [];
          this.DayPowerSumWmsUser = 0;
          this.DaySpcificYeildWmsUser = 0;
          this.data_Day = [];
          if (result.status) {
            this.DayPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.DaySpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            var graphDetailsArray = result.resultObject;
            for (let i = 0; i < graphDetailsArray.length; i++) {
              if (graphDetailsArray[i].date_time) {
                let stringToSplit = graphDetailsArray[i].date_time;
                let x = stringToSplit.split(" ");
                this.categories_Day.push(x[1]);
                this.data_Day.push(Number(graphDetailsArray[i].power_generation));
              }

            }
            this.chartDayOptions.series = [{
              name: 'Power Generated in KW',
              data: this.data_Day
            },];

            this.chartDayOptions.xAxis = [{
              categories: this.categories_Day
            },];

            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // all inverter day graph

  public normalUserInverterWiseDayGraph() {

    this.Inv_Data = [];
    this.energy = [];
      this.dayGraphObjInv = {
      date: this.pipe.transform(this.dayform.controls['dayDate'].value, "yyyy-MM-dd"),
      user_id: this.login_Id,
    }
    this.dashboardService.wmsUserEnergyDayGraphAllInv(this.dayGraphObjInv)
      .pipe().subscribe(
        async result => {
          this.Inv_Data = [];
          this.energy = [];
          this.DayPowerSumWmsUserInv = 0;
          this.DaySpcificYeildWmsUserInv = 0;
          this.data_Day = [];
          if (result.status) {
            // this.DayPowerSumWmsUserInv = result.resultObject.total_energy.toFixed(2);
            // this.DaySpcificYeildWmsUserInv = result.resultObject.specific_yield.toFixed(2);
            this.DayPowerSumWmsUserInv = result.resultObject.total_energy;
            this.DaySpcificYeildWmsUserInv = result.resultObject.specific_yield;
            var graphDetailsArray = result.resultObject.inverterInfo;
            for (let i = 0; i < graphDetailsArray.length; i++) {
              this.Inv_Data.push(graphDetailsArray[i].inv_name);
              this.energy.push(Number(graphDetailsArray[i].energy));
            }

            this.chartDayOptionsDg.series = [{
              name: 'Energy Generated in KWh',
              data: this.energy
            },];

            this.chartDayOptionsDg.xAxis = [{
              categories: this.Inv_Data
            },];

            this.updateFlag = true;
          }
          else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // Dynamic monthgraph for normal user
  public wmsUserInverterMonthGraph() {
    this.graphMonthObj = {
      month: this.pipe.transform(this.monthform.controls['monthYear'].value, "MM"),
      year: this.pipe.transform(this.monthform.controls['monthYear'].value, "yyyy"),
      user_id: this.login_Id,
      serial_no: this.wmsSerial_no,
      sub_device_id: this.wmsSubDevice_id
    }
    this.dashboardService.normalUserEnergyMonthGraph(this.graphMonthObj)
      .pipe(takeUntil(this.ResponseWmsInverterDetails))
      .subscribe(
        async result => {
          this.month_Categories = [];
          this.month_Data = [];
          this.monthSpcificYeildWmsUser = 0;
          this.monthPowerSumWmsUser = 0;
          if (result.status) {
            this.monthPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.monthSpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            var graphDetailsArray = result.resultObject;
            for (let i = 0; i < graphDetailsArray.length; i++) {
              if (graphDetailsArray[i].date) {
                this.month_Categories.push(graphDetailsArray[i].date);
                this.month_Data.push(Number(graphDetailsArray[i].power_generation));
              }
            }
            this.chartMonthOptions.series = [{
              name: 'Energy Generated in KWh',
              data: this.month_Data
            },];

            this.chartMonthOptions.xAxis = [{
              categories: this.month_Categories
            },];

            this.updateFlag = true;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // for all inv moth graph for all inv
  public wmsUserInverterMonthInvGraph() {

    this.graphMonthObjInv = {
      user_id: this.login_Id,
      month: this.pipe.transform(this.monthform.controls['monthYear'].value, "MM"),
      year: this.pipe.transform(this.monthform.controls['monthYear'].value, "yyyy"),
           }
    this.dashboardService.wmsUserEnergyMonthGraphInv(this.graphMonthObjInv)
      .pipe()
      .subscribe(
        async result => {

          this.Inv_Data_Mon = [];
          this.energy_mon = [];
          this.monthSpcificYeildWmsUserInv = 0;
          this.monthPowerSumWmsUserInv = 0;
          if (result.status) {
            this.monthPowerSumWmsUserInv = result.resultObject.total_energy;
            this.monthSpcificYeildWmsUserInv = result.resultObject.specific_yield;
            var graphDetailsArray = result.resultObject.inverter_info;
           for (let i = 0; i < graphDetailsArray.length; i++) {
              this.Inv_Data_Mon.push(graphDetailsArray[i].inv_name);
              this.energy_mon.push(Number(graphDetailsArray[i].energy));
            }
            this.chartMonthOptionsInv.series = [{
              name: 'Energy Generated in KWh',
              data: this.energy_mon
            },];

            this.chartMonthOptionsInv.xAxis = [{
              categories: this.Inv_Data_Mon
            },];

            this.updateFlag = true;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // Dynamic year graph for normal user for each inv
  public wmsUseInverterYearGraph() {
    this.graphYearObj = {
      year: this.pipe.transform(this.yearform.controls['year'].value, "yyyy"),
      user_id: this.login_Id,
      serial_no: this.wmsSerial_no,
      sub_device_id: this.wmsSubDevice_id
    }
    this.dashboardService.normalUserEnergyYearGraph(this.graphYearObj)
      .pipe(takeUntil(this.ResponseWmsInverterDetails))
      .subscribe(
        async result => {
          this.years_Categories = [];
          this.years_Data = [];
          this.yearPowerSumWmsUser = 0;
          this.yearSpcificYeildWmsUser = 0;
          if (result.status) {
            this.yearPowerSumWmsUser = result.sum_power_gen.toFixed(2);
            this.yearSpcificYeildWmsUser = result.specific_yeild.toFixed(2);
            this.graphDetailsArray = result.resultObject;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
              if (this.graphDetailsArray[i].month) {
                this.years_Categories.push(this.graphDetailsArray[i].month);
                this.years_Data.push(Number(this.graphDetailsArray[i].power_generation));
              }
            }
            this.chartYearOptions.series = [{
              name: 'Energy Generated in KWh',
              data: this.years_Data
            },];

            this.chartYearOptions.xAxis = [{
              categories: this.years_Categories
            },];

            this.updateFlag = true;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }


  // Dynamic year graph for normal user for all inv
  public wmsUseInverterYearInvGraph() {
    this.graphYearObjInv = {
      year: this.pipe.transform(this.yearform.controls['year'].value, "yyyy"),
      user_id: this.login_Id

    }
    this.dashboardService.wmsUserEnergyYearGraphInv(this.graphYearObjInv)
      .pipe(takeUntil(this.ResponseWmsInverterDetails))
      .subscribe(
        async result => {
          this.years_Categories = [];
          this.years_Data = [];
          this.yearPowerSumWmsUserInv = 0;
          this.yearSpcificYeildWmsUserInv = 0;
          if (result.status) {

            this.yearPowerSumWmsUserInv = result.resultObject.total_energy;
            this.yearSpcificYeildWmsUserInv = result.resultObject.specific_yield;

            this.graphDetailsArray = result.resultObject.inverter_info ;
            for (let i = 0; i < this.graphDetailsArray.length; i++) {
               this.years_Categories.push(this.graphDetailsArray[i].inv_name);
                this.years_Data.push(Number(this.graphDetailsArray[i].energy));
            }

              this.chartYearOptionsInv.series = [{
              name: 'Energy Generated in KWh',
              data: this.years_Data
            },];

            this.chartYearOptionsInv.xAxis = [{
              categories: this.years_Categories
            },];

            this.updateFlag = true;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }

  // Dynamic lifetime graph for normal user for each inv
  public wmsUseInverterLifeTimeGraph() {

    this.graphLifeTimeObj = {
      start_year: "2017",
      user_id: this.login_Id,
      serial_no: this.wmsSerial_no,
      sub_device_id: this.wmsSubDevice_id
    }
    this.dashboardService.normalUserEnergyLifeTimeGraph(this.graphLifeTimeObj)
      .pipe(takeUntil(this.ResponseWmsInverterDetails))
      .subscribe(
        async result => {
          this.LifeTimeCategories = [];
          this.LifeTimeData = [];
          this.lifeTimePowerSumWmsUser = 0;
          if (result.status) {
            this.lifeTimePowerSumWmsUser = result.sum_power_gen.toFixed(2);
            var graphDetailsArray = result.resultObject;
            for (let i = 0; i < graphDetailsArray.length; i++) {
              if (graphDetailsArray[i].year) {
                this.LifeTimeCategories.push(graphDetailsArray[i].year);
                this.LifeTimeData.push(Number(graphDetailsArray[i].power_generation));
              }
            }
            this.chartLifeTimeOptions.series = [{
              name: 'Energy Generated in KWh',
              data: this.LifeTimeData
            },];

            this.chartLifeTimeOptions.xAxis = [{
              categories: this.LifeTimeCategories
            },];

            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // Dynamic lifetime graph for normal user for each inv
  public wmsUseInverterLifeTimeInvGraph() {
    this.graphLifeTimeObjInv = {
      year: "2017",
      user_id: this.login_Id

    }
    this.dashboardService.wmsUserEnergyLifeTimeGraphInv(this.graphLifeTimeObjInv)
      .pipe(takeUntil(this.ResponseWmsInverterDetails))
      .subscribe(
        async result => {
          this.LifeTimeCategories = [];
          this.LifeTimeData = [];
          this.lifeTimePowerSumWmsUserAll = 0;
          if (result.status) {
            // this.lifeTimePowerSumWmsUserAll = result.sum_power_gen.toFixed(2);
            this.lifeTimePowerSumWmsUserAll = result.resultObject.total_energy;

            var graphDetailsArray = result.resultObject.inverter_info;
            for (let i = 0; i < graphDetailsArray.length; i++) {
              if (graphDetailsArray[i].inv_name) {
                this.LifeTimeCategories.push(graphDetailsArray[i].inv_name);
                this.LifeTimeData.push(Number(graphDetailsArray[i].energy));
              }
            }
            this.chartLifeTimeOptionsInv.series = [{
              name: 'Energy Generated in KWh',
              data: this.LifeTimeData
            },];

            this.chartLifeTimeOptionsInv.xAxis = [{
              categories: this.LifeTimeCategories
            },];

            this.updateFlag = true;
          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  showParameterTrendsTab(tab) {
    this.tabselection = tab;
    this.selectedTabSection = 'Day';
    this.dayform.get('dayDate').setValue(new Date());
    this.normalUserInverterWiseDayGraph();
  }
  showDownloadReportab(tab) {
    this.tabselection = tab;
    this.selectedTabSection = 'Day';
    this.dayform.get('dayDate').setValue(new Date());
    this.normalUserInverterWiseDayGraph();
  }
  ngOnDestroy() {
    this.ResponseWmsInverterDetails.next();
    this.ResponseWmsInverterDetails.complete();
    this.ResponsWmsUserInverterList.next();
    this.ResponsWmsUserInverterList.complete();
    this.ResponseParmeterAndValue.next();
    this.ResponseParmeterAndValue.complete();
  }

}
